export const labelStyle = {
  color: '#838383',
}
